import Expander from 'bitmovin-web-ui/src/components/generic/expander';
import baseVariables from 'bitmovin-web-ui/src/styles/baseVariables';
import React from 'react';
import styled from 'styled-components';

import CaretDownGraySvg from '../media/caret_down_gray.svg';
import CaretUpSvg from '../media/caret_up.svg';

import {pxToEm} from './globalStyles';

//#region Styled Components

const expanderBorderSize = '1px';
const StyledExpander = styled(Expander)`
  background-color: white;
  border-radius: ${baseVariables.sizes.borderRadius};
  border: ${expanderBorderSize} solid ${baseVariables.colors.darkBlueGray};
`;

const paddingVerticalPx = 16;
const paddingHorizontalPx = 28;
const StyledClickableDiv = styled.div`
  border-radius: ${baseVariables.sizes.borderRadius};
  padding: ${pxToEm(paddingVerticalPx)}em ${pxToEm(paddingHorizontalPx)}em;
  cursor: pointer;

  display: flex;
  justify-content: space-between;
  align-items: center;

  :hover {
    background-color: ${baseVariables.colors.lightBlueGray};
  }
`;

const StyledSpan = styled.span`
  font-size: ${pxToEm(22)}em;
  color: ${baseVariables.colors.midnight};
  flex-grow: 1;
`;

const StyledImg = styled.img`
  margin-left: ${pxToEm(paddingHorizontalPx)}em;
`;

const StyledContentDiv = styled.div`
  padding: ${pxToEm(paddingVerticalPx)}em ${pxToEm(paddingHorizontalPx)}em;
`;

//#endregion

interface Props {
  className?: string;
  expanded: boolean;
  headline: string;
  onExpand: (expand: boolean) => void;
}

const AccordionPanel: React.FunctionComponent<Props> = ({className, children, expanded, headline, onExpand}) => (
  <StyledExpander
    className={className}
    alwaysVisible={
      <StyledClickableDiv onClick={() => onExpand(!expanded)}>
        <StyledSpan>{headline}</StyledSpan>
        <StyledImg src={expanded ? CaretUpSvg : CaretDownGraySvg} alt={expanded ? 'caret up' : 'caret down'} />
      </StyledClickableDiv>
    }
    expanded={expanded}>
    <StyledContentDiv>{children}</StyledContentDiv>
  </StyledExpander>
);

export default AccordionPanel;
